Apt.fn.extend('account.profile', {}, {
	/**
	 * Initialize avatar application
	 *
	 * @param {Object} data
	 */
	initAvatar(data) {
		const scope = this;
		const $avatar = $$('profileAvatar');

		scope.avatar = $.app.make('avatar', {
			view: $$('avatar')[0].textContent,
			target: $avatar,
			model: data
		});

		scope.bindImage();
	},

	/**
	 * Bind profile image events
	 */
	bindImage() {
		const $input = $$('avatarInput');
		const $form = $$('avatarForm');
		const processingClass = '-is-processing';
		const path = `${this.root}/image`;

		$$('avatarUpload').on('click', () => {
			$input[0].click();
		}, {
			delegate: '$profileAvatar',
			namespace: 'profile'
		});

		$$('avatarRemove').on('click', () => {
			LS.api.delete(path, {
				auth: true,
				success: () => {
					$.app.avatar.$drop('image');
				}
			});
		}, {
			delegate: '$profileAvatar',
			namespace: 'profile'
		});

		$input.on('change', (e, el) => {
			if (el.files.length < 1) {
				return;
			}

			const file = el.files[0];
			const allowed = [
				'image/avif',
				'image/gif',
				'image/jpeg',
				'image/png',
				'image/webp'
			];
			const img = new Image();

			if (! allowed.includes(file.type)) {
				LS.util.warn('Only image files are allowed', {
					type: file.type
				});

				return;
			}

			img.addEventListener('load', () => {
				let valid = true;

				if (img.width < 360 || img.height < 360) {
					valid = false;

					LS.util.warn('Headshot must be at least 360x360px', true);
				}

				if (valid) {
					$form.addClass(processingClass);

					LS.util.flash('Processing headshot — please wait', null, {
						timeout: 30000
					});

					LS.api.post(path, {
						auth: true,
						data: new FormData($form[0]),
						processData: false,
						headers: {
							'Content-Type': false
						},
						success: data => {
							$.app.avatar.$merge({
								image: data.image,
								bust: '?' + Date.now()
							});
						},
						error: () => {
							$input.val('');

							$.app.avatar.$drop('image');
						},
						complete: () => {
							el.value = '';

							$form.removeClass(processingClass);
						}
					});
				}

				URL.revokeObjectURL(img.src);
			}, {
				once: true
			});

			img.src = URL.createObjectURL(file);
		}, {
			namespace: 'profile'
		});
	}
});